<template>
  <div class="img-text-card">
    <div class="caigou" @click="handleClick">
      <div class="menu-icon">
        <img :src="img" alt="" />
      </div>
      <p>{{ text }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: ''
    },
    img: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleClick() {
      this.$emit('handleClick')
    }
  }
}
</script>

<style lang="scss">
.img-text-card {
  .caigou {
    background: #ffffff;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    cursor: pointer;
    p {
      font-size: 11px;
      font-weight: bold;
      color: #333333;
    }
    p:hover {
      color: #ce2939;
    }
    .menu-icon {
      width: 34px;
      height: 34px;
      margin-bottom: 7px;
      img {
        width: 100%;
        height: auto;
      }
    }
  }
}
</style>
